import React from "react";
import { CONTENTS } from "./data";
import TableOfContent from "../../../component/guidelines/TableOfContent";

const Eula = () => {
    return (
        <div
            style={{
                color: "#333",
                maxWidth: "800px",
                lineHeight: "1.6",
            }}
        >
            <h1
                style={{
                    fontSize: "48px",
                    fontWeight: "bold",
                    marginBottom: "30px",
                    color: "#222",
                }}
            >
                END USER LICENSE AGREEMENT
            </h1>
            <div
                style={{
                    marginBottom: "30px",
                }}
            >
                <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
                    Last updated November 13, 2024
                </p>
                <p style={{ marginBottom: "20px" }}>
                    itump is licensed to You (End-User) by 24One, Inc., located and registered at 30 Wall Street, New York, New York 10005,
                    {" "}United States ("Licensor"), for use only under the terms of this License Agreement.
                    <br/><br/>
                    By downloading the Licensed Application from Apple's software distribution platform ("App Store") and Google's software distribution platform ("Play Store"),
                    {" "}and any update thereto (as permitted by this License Agreement), You indicate that You agree to be bound by all of the terms and conditions of this License Agreement, and that You accept this License Agreement.
                    {" "}App Store and Play Store are referred to in this License Agreement as "Services."
                    <br/><br/>
                    The parties of this License Agreement acknowledge that the Services are not a Party to this License Agreement and
                    {" "}are not bound by any provisions or obligations with regard to the Licensed Application, such as warranty, liability,
                    {" "}maintenance and support thereof. 24One, Inc., not the Services, is solely responsible for the Licensed Application and the content thereof.
                    <br/><br/>
                    This License Agreement may not provide for usage rules for the Licensed Application that are in conflict with the
                    {""}latest Apple Media Services Terms and Conditions and Google Play Terms of Service ("Usage Rules"). 24One, Inc.
                    {" "}acknowledges that it had the opportunity to review the Usage Rules and this License Agreement is not conflicting with them.
                    <br/><br/>
                    itump when purchased or downloaded through the Services, is licensed to You for use only under the terms of this License Agreement.
                    {" "}The Licensor reserves all rights not expressly granted to You. itump is to be used on devices that operate
                    {" "}with Apple's operating systems ("iOS" and "Mac OS") or Google's operating system ("Android").
                </p>
            </div>
            <hr
            style={{
                border: "none",
                borderBottom: "1px solid #e0e0e0",
                margin: "30px 0",
            }}
            />
            <section style={{ marginBottom: "30px" }}>
                <h2
                    style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        marginBottom: "15px",
                    }}
                >
                    TABLE OF CONTENTS
                </h2>
                <TableOfContent contents={CONTENTS} />
            </section>
            <dl>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="application"
                    >
                        1. THE APPLICATION
                    </dt>
                    <dd>
                        itump ("Licensed Application") is a piece of software created to The purpose of the itump app is to serve as a mobile-first,
                        {" "}all-in-one platform that simplifies business management for entrepreneurs and small businesses. It offers services such as business formation,
                        {" "}compliance tracking, payment processing, business credit building, and tax filing. With tools powered by AI, Fintech, and
                        {" "}Web3 technologies, itump streamlines critical processes like report generating, document management, and scaling strategies,
                        {" "}enabling users to manage their business operations efficiently, stay compliant, and focus on growth—all from their mobile devices. —
                        {" "}and customized for iOS and Android mobile devices ("Devices"). It is used to The main use of the itump app is to provide entrepreneurs
                        {" "}and small businesses with an integrated platform for managing essential business operations. It simplifies tasks such as business formation,
                        {" "}compliance tracking, payment processing, credit building, and document storage. By combining tools powered by AI, Fintech, and Web3,
                        {" "}the app allows users to stay compliant, track business health, and scale their ventures efficiently—all from a mobile-first platform.
                        {" "}Itump is designed to save time, encourage green economy, reduce complexity, and empower business growth.
                        <br/><br/>
                        The Licensed Application is not tailored to comply with industry-specific regulations
                        {" "}(Health Insurance Portability and Accountability Act (HIPAA), Federal Information Security Management Act (FISMA), etc.),
                        {" "}so if your interactions would be subjected to such laws, you may not use this Licensed Application.
                        {" "}You may not use the Licensed Application in a way that would violate the Gramm-Leach-Bliley Act (GLBA).
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="license"
                    >
                        2. SCOPE OF LICENSE
                    </dt>
                    <dd>
                        <div>
                            2.1  You are given a non-transferable, non-exclusive, non-sublicensable license to install and
                            {" "}use the Licensed Application on any Devices that You (End-User) own or control and as
                            {" "}permitted by the Usage Rules, with the exception that such Licensed Application may be
                            {" "}accessed and used by other accounts associated with You (End-User, The Purchaser) via Family Sharing or volume purchasing.
                        </div>
                        <br />
                        <div>
                            2.2  This license will also govern any updates of the Licensed Application provided by Licensor that
                            {" "}replace, repair, and/or supplement the first Licensed Application, unless a separate license is provided
                            {" "}for such update, in which case the terms of that new license will govern.
                        </div>
                        <br />
                        <div>
                            2.3  You may not share or make the Licensed Application available to third parties
                            {" "}(unless to the degree allowed by the Usage Rules, and with 24One, Inc.'s prior written consent),
                            {" "}sell, rent, lend, lease or otherwise redistribute the Licensed Application.
                        </div>
                        <br />
                        <div>
                            2.4  You may not reverse engineer, translate, disassemble, integrate, decompile, remove, modify,
                            {" "}combine, create derivative works or updates of, adapt, or attempt to derive the source code of
                            {" "}the Licensed Application, or any part thereof (except with 24One, Inc.'s prior written consent).
                        </div>
                        <br />
                        <div>
                            2.5 You may not copy (excluding when expressly authorized by this license and the Usage Rules)
                            {" "}or alter the Licensed Application or portions thereof. You may create and store copies
                            {" "}only on devices that You own or control for backup keeping under the terms of this license,
                            {" "}the Usage Rules, and any other terms and conditions that apply to the device or software used.
                            {" "}You may not remove any intellectual property notices. You acknowledge that no unauthorized third
                            {" "}parties may gain access to these copies at any time. If you sell your Devices to a third party,
                            {" "}you must remove the Licensed Application from the Devices before doing so.
                        </div>
                        <br />
                        <div>
                            2.6  Violations of the obligations mentioned above, as well as the attempt of such infringement, may be subject to prosecution and damages.
                        </div>
                        <br />
                        <div>
                            2.7  Licensor reserves the right to modify the terms and conditions of licensing
                        </div>
                        <br />
                        <div>
                            2.8  Nothing in this license should be interpreted to restrict third-party terms. When using the Licensed Application,
                            {" "}You must ensure that You comply with applicable third-party terms and conditions.
                        </div>
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="requirements"
                    >
                        3. TECHNICAL REQUIREMENTS
                    </dt>
                    <dd>
                        <div>
                            3.1  The Licensed Application requires a firmware version 1.0.0 or higher. Licensor recommends using the latest version of the firmware.
                        </div>
                        <br/>
                        <div>
                            3.2  Licensor attempts to keep the Licensed Application updated so that it complies with modified/new versions
                            {" "}of the firmware and new hardware. You are not granted rights to claim such an update.
                        </div>
                        <br/>
                        <div>
                            3.3  You acknowledge that it is Your responsibility to confirm and determine that the app end-user device on
                            {" "}which You intend to use the Licensed Application satisfies the technical specifications mentioned above.
                        </div>
                        <br/>
                        <div>
                            3.4  Licensor reserves the right to modify the technical specifications as it sees appropriate at any time.
                        </div>
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="maintenance"
                    >
                        4. MAINTENANCE AND SUPPORT
                    </dt>
                    <dd>
                        <div>
                            4.1  The Licensor is solely responsible for providing any maintenance and support services for this Licensed Application.
                            {" "}You can reach the Licensor at the email address listed in the App Store or Play Store Overview for this Licensed Application.
                        </div>
                        <br/>
                        <div>
                            4.2  24One, Inc. and the End-User acknowledge that the Services have no obligation whatsoever to furnish any maintenance
                            {" "}and support services with respect to the Licensed Application.
                        </div>
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="use-of-data"
                    >
                        5. USE OF DATA
                    </dt>
                    <dd>
                        You acknowledge that Licensor will be able to access and adjust Your downloaded Licensed Application
                        {" "}content and Your personal information, and that Licensor's use of such material and information
                        {" "}is subject to Your legal agreements with Licensor and Licensor's privacy policy, which can be found at the bottom of the Licensed Application.
                        <br/><br/>                        
                        You acknowledge that the Licensor may periodically collect and use technical data and related information about your
                        {" "}device, system, and application software, and peripherals, offer product support, facilitate the software updates,
                        {" "}and for purposes of providing other services to you (if any) related to the Licensed Application.
                        {" "}Licensor may also use this information to improve its products or to provide services or technologies to you,
                        {" "}as long as it is in a form that does not personally identify you.
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="user-contributions"
                    >
                        6. USER-GENERATED CONTRIBUTIONS
                    </dt>
                    <dd>
                        <div>
                            The Licensed Application does not offer users to submit or post content. We may provide
                            {" "}you with the opportunity to create, submit, post, display, transmit, perform, publish,
                            {" "}distribute, or broadcast content and materials to us or in the Licensed Application,
                            {" "}including but not limited to text, writings, video, audio, photographs, graphics, comments,
                            {" "}suggestions, or personal information or other material (collectively, "Contributions").
                            {" "}Contributions may be viewable by other users of the Licensed Application and through third-party
                            {" "}websites or applications. As such, any Contributions you transmit may be treated in accordance with
                            {" "}the Licensed Application Privacy Policy. When you create or make available any Contributions, you thereby represent and warrant that:
                        </div>
                        <br/>
                        <ol
                            style={{
                                paddingLeft: "40px",
                                marginBottom: "15px"
                            }}
                        >
                            <li style={{ marginBottom: "10px", }}>
                                The creation, distribution, transmission, public display, or performance, and the accessing, downloading, 
                                {" "}or copying of your Contributions do not and will not infringe the proprietary rights, including but
                                {" "}not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                You are the creator and owner of or have the necessary licenses, rights, consents, releases,
                                {" "}and permissions to use and to authorize us, the Licensed Application, and other users of
                                {" "}the Licensed Application to use your Contributions in any manner contemplated by the Licensed Application and this License Agreement.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                You have the written consent, release, and/or permission of each and every identifiable individual person in
                                {" "}your Contributions to use the name or likeness or each and every such identifiable individual person to
                                {" "}enable inclusion and use of your Contributions in any manner contemplated by the Licensed Application and this License Agreement.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your Contributions are not false, inaccurate, or misleading.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes,
                                {" "}chain letters, spam, mass mailings, or other forms of solicitation.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous,
                                {" "}slanderous, or otherwise objectionable (as determined by us).
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your contributions are not used to harass or threaten (in the legal sense of those terms) any other person
                                {" "}and to promote violence against a specific person or class of people.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your Contributions do not violate any applicable law, regulation, or rule.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your Contributions do not violate the privacy or publicity rights of any third party.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your Contributions do not violate any applicable law concerning child pornography, or otherwise
                                {" "}intended to protect the health or well-being of minors.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your Contributions do not include any offensive comments that are connected to race,
                                {" "}national origin, gender, sexual preference, or physical handicap.
                            </li>
                            <li style={{ marginBottom: "10px", }}>
                                Your Contributions do not otherwise violate, or link to material that violates, any
                                {" "}provision of this License Agreement, or any applicable law or regulation.
                            </li>
                        </ol>
                        <div>
                            Any use of the Licensed Application in violation of the foregoing violates this License Agreement
                            {" "}and may result in, among other things, termination or suspension of your rights to use the Licensed Application.
                        </div>
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="contribution-license"
                    >
                        7. CONTRIBUTION LICENSE
                    </dt>
                    <dd>
                        You agree that we may access, store, process, and use any information and personal data that
                        {" "}you provide following the terms of the Privacy Policy and your choices (including settings).
                        <br/><br/>
                        By submitting suggestions of other feedback regarding the Licensed Application, you agree that
                        {" "}we can use and share such feedback for any purpose without compensation to you.
                        <br/><br/>
                        We do not assert any ownership over your Contributions. You retain full ownership of all of your
                        {" "}contributions and any intellectual property rights or other proprietary rights associated with
                        {" "}your Contributions. We are not liable for any statements or representations in your contributions
                        {" "}provided by you in any area in the Licensed Application. You are solely responsible for your
                        {" "}contributions to the Licensed Application and you expressly agree to exonerate us from any and
                        {" "}all responsibility and to refrain from any legal action against us regarding your Contributions
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="liability"
                    >
                        8. LIABILITY
                    </dt>
                    <dd>
                        Licensor takes no accountability or responsibility for any damages caused due to a breach of duties
                        {" "}according to Section 2 of this License Agreement. To avoid data loss, You are required to make
                        {" "}use of backup functions of the Licensed Application to the extent allowed by applicable third-party
                        {" "}terms and conditions of use. You are aware that in case of alterations or manipulations of the
                        {" "}Licensed Application, You will not have access to the Licensed Application.
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="warranty"
                    >
                        9. WARRANTY
                    </dt>
                    <dd>
                        <div>
                            9.1  Licensor warrants that the Licensed Application is free of spyware, trojan horses,
                            {" "}viruses, or any other malware at the time of Your download. Licensor warrants that 
                            {" "}the Licensed Application works as described in the user documentation.
                        </div>
                        <br/>
                        <div>
                            9.2  No warranty is provided for the Licensed Application that is not executable on the device,
                            {" "}that has been unauthorizedly modified, handled inappropriately or culpably, combined or installed
                            {" "}with inappropriate hardware or software, used with inappropriate accessories, regardless if by 
                            {" "}Yourself or by third parties, or if there are any other reasons outside of 24One, Inc.'s sphere
                            {" "}of influence that affect the executability of the Licensed Application.
                        </div>
                        <br/>
                        <div>
                            9.3  You are required to inspect the Licensed Application immediately after installing it
                            {" "}and notify 24One, Inc. about issues discovered without delay by email provided in Contact Information.
                            {" "}The defect report will be taken into consideration and further investigated if it has
                            {" "}been emailed within a period of thirty (30) days after discovery.
                        </div>
                        <br/>
                        <div>
                            9.4  If we confirm that the Licensed Application is defective, 24One, Inc. reserves a choice
                            {" "}to remedy the situation either by means of solving the defect or substitute delivery.
                        </div>
                        <br/>
                        <div>
                            9.5  In the event of any failure of the Licensed Application to conform to any applicable warranty,
                            {" "}You may notify the Services Store Operator, and Your Licensed Application purchase price will be
                            {" "}refunded to You. To the maximum extent permitted by applicable law, the Services Store Operator will
                            {" "}have no other warranty obligation whatsoever with respect to the Licensed Application, and any other
                            {" "}losses, claims, damages, liabilities, expenses, and costs attributable to any negligence to adhere to any warranty
                        </div>
                        <br/>
                        <div>
                            9.6  If the user is an entrepreneur, any claim based on faults expires after a statutory period of
                            {" "}limitation amounting to twelve (12) months after the Licensed Application was made available to the user.
                            {" "}The statutory periods of limitation given by law apply for users who are consumers.
                        </div>
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="product-claims"
                    >
                        10. PRODUCT CLAIMS
                    </dt>
                    <dd>
                        <div>
                            24One, Inc. and the End-User acknowledge that 24One, Inc., and not the Services, is responsible for addressing
                            {" "}any claims of the End-User or any third party relating to the Licensed Application or the End-User&apos;s
                            {" "}possession and/or use of that Licensed Application, including, but not limited to:
                        </div>
                        <br/>
                        <div
                            style={{
                                paddingLeft: "25px"
                            }}
                        >
                            <div className="d-flex align-items-baseline gap-2">
                                <div style={{ fontSize: 18 }}>(i)</div>
                                <div className="flex-1">
                                    product liability claims;
                                </div>
                            </div>
                            <div className="d-flex align-items-baseline gap-2">
                                <div style={{ fontSize: 18 }}>(ii)</div>
                                <div className="flex-1">
                                    any claim that the Licensed Application fails to conform to any applicable legal or regulatory requirement; and
                                </div>
                            </div>
                            <div className="d-flex align-items-baseline gap-2">
                                <div style={{ fontSize: 18 }}>(iii)</div>
                                <div className="flex-1">
                                    claims arising under consumer protection, privacy, or similar legislation, including
                                    {" "}in connection with Your Licensed Application’s use of the HealthKit and HomeKit.
                                </div>
                            </div>
                        </div>
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="legal-compliance"
                    >
                        11. LEGAL COMPLIANCE
                    </dt>
                    <dd>
                        You represent and warrant that You are not located in a country that is subject to a US Government
                        {" "}embargo, or that has been designated by the US Government as a "terrorist supporting" country;
                        {" "}and that You are not listed on any US Government list of prohibited or restricted parties.
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="contact-information"
                    >
                        12. CONTACT INFORMATION
                    </dt>
                    <dd>
                        For general inquiries, complaints, questions or claims concerning the Licensed Application, please contact:
                        <br/><br/>
                        Legal Support Team
                        <br/>
                        30 Wall Street
                        <br/>
                        New York, NY 10005
                        <br/>
                        United States
                        <br/>
                        g.legals@itump.com
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="termination"
                    >
                        13. TERMINATION
                    </dt>
                    <dd>
                        The license is valid until terminated by 24One, Inc. or by You. Your rights under this license will terminate
                        {" "}automatically and without notice from 24One, Inc. if You fail to adhere to any term(s) of this license.
                        {" "}Upon License termination, You shall stop all use of the Licensed Application, and destroy all copies, full or partial, of the Licensed Application.
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="third-party-terms"
                    >
                        14. THIRD-PARTY TERMS OF AGREEMENTS AND BENEFICIARY
                    </dt>
                    <dd>
                        24One, Inc. represents and warrants that 24One, Inc. will comply with applicable third-party terms of agreement when using Licensed Application.
                        {" "}In Accordance with Section 9 of the "Instructions for Minimum Terms of Developer's End-User License Agreement,"
                        {" "}both Apple and Google and their subsidiaries shall be third-party beneficiaries of this End User License Agreement
                        {" "}and — upon Your acceptance of the terms and conditions of this License Agreement, both Apple and Google will have the right
                        {" "}(and will be deemed to have accepted the right) to enforce this End User License Agreement against You as a third-party beneficiary thereof.
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="intellectual-rights"
                    >
                        15. INTELLECTUAL PROPERTY RIGHTS
                    </dt>
                    <dd>
                        24One, Inc. and the End-User acknowledge that, in the event of any third-party claim that the Licensed
                        {" "}Application or the End-User's possession and use of that Licensed Application infringes on the third
                        {" "}party's intellectual property rights, 24One, Inc., and not the Services, will be solely responsible
                        {" "}for the investigation, defense, settlement, and discharge or any such intellectual property infringement claims.
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="applicable-law"
                    >
                        16. APPLICABLE LAW
                    </dt>
                    <dd>
                        This License Agreement is governed by the laws of the State of Delaware excluding its conflicts of law rules.
                    </dd>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <dt
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginBottom: "15px",
                        }}
                        id="miscellaneous"
                    >
                        17. MISCELLANEOUS
                    </dt>
                    <dd>
                        <div>
                            17.1  If any of the terms of this agreement should be or become invalid, the validity of the remaining
                            {" "}provisions shall not be affected. Invalid terms will be replaced by valid ones formulated in a way that will achieve the primary purpose.
                        </div>
                        <br/>
                        <div>
                            17.2  Collateral agreements, changes and amendments are only valid if laid down
                            {" "}in writing. The preceding clause can only be waived in writing.
                        </div>
                    </dd>
                </div>
            </dl>
        </div>
    )
}

export default Eula
